import { Component, OnInit } from '@angular/core';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import { ContractorRegistrationDecisionActivityInputComponent } from '../contractor-registration-decision-activity/contractor-registration-decision-activity-input/contractor-registration-decision-activity-input.component';

@Component({
    selector: 'wm-contractor-renewal-decision-activity-input',
    templateUrl: './contractor-renewal-decision-activity-input.component.html',
    styleUrls: ['./contractor-renewal-decision-activity-input.component.css'],
    standalone: false
})
export class ContractorRenewalDecisionActivityInputComponent
  extends ContractorRegistrationDecisionActivityInputComponent
  implements OnInit {
  constructor() {
    super();
  }
}
